// ==UserScript==// @name  Script Widget Genesys
// @namespace
// @version      	0.1
// @description  	Configuration liee au site SAMY
// @environnement 	DEV
// @author       	Ceritek
// @match
// @grant        	none

/***************************************************/
// Host et port à configurer

var genDevUrl = "https://genesys.legallais.tech";
var genProdUrl = "https://prod-genesys.legallais.tech";

var genUrl = __GENESYS__ ? genDevUrl : genProdUrl;

const WidgetsConfig = {
	gmsHost: genUrl,
	gmsPort: "8080",
	cobrowseHost: genUrl,
	cobrowsePort: "8443",
	widgetHost: genUrl,
	countdown: "300000",
	apparitionChatBox: "15000",
	CalendrierServiceChat: "Heures_Equipe_1",
	CalendrierServiceCallback: "Heures_Equipe_1",
	CallbackServiceName: "CallBack-Preview",
	ChatServiceName: "InteractionChats",
	debug: "1",
};

export default WidgetsConfig;



// WEBPACK FOOTER //
// ./genesys/widgets/conf/GEN_widgets_conf.js